import store from "@/store";
import { SiteModel } from "@/models/SiteModel";
import { UserModel } from "@/models/UserModel";
import { ImageModel } from "@/models/ImageModel";
import FallbackDB from "@/libraries/localStorage";
import { addMagicMethods } from "@/helpers/addMagicMethods";
import { formatTimer, getNow } from "@/helpers/date_time";
import { saveImageToLocalDB } from "@/helpers/saveImageToLocalDB";
export class TaskModel extends SiteModel {
    constructor(id = null) {
        super('tasks', +id);
        return addMagicMethods(this);
    }
    getTableData() {
        return store.getters['shifts/getTasks'] || [];
    }
    setTableData(data) {
        store.commit('shifts/setTasks', data);
        FallbackDB.save('tasks', data);
    }
    static onSuccessSubmit(response) {
        return super.onSuccessSubmit('TaskModel', response);
    }
    async getDataToSend() {
        const data = this.getData();
        if (data.photo_1.includes('ref_')) {
            data.photo_1 = await this.photo_1__byRef;
        }
        return data;
    }
    flush() {
        return super.flush('TaskModel', 'tasks');
    }
    __get(target, prop, receiver) {
        var _a;
        switch (prop) {
            case 'user':
                return new UserModel(+receiver.user_id);
            case 'deadline_inFormat':
                return formatTimer(receiver.deadline_time_only, false);
            case 'is_done':
                return +receiver.status === TaskModel.STATUS_DONE;
            case '_is_done':
                return (_a = target.data._is_done) !== null && _a !== void 0 ? _a : receiver.is_done;
            case 'photo_1__byRef':
                const id = parseInt(receiver.photo_1.replace('ref_', ''));
                const m = new ImageModel(id);
                return new Promise(async (resolver) => {
                    await m.init();
                    resolver(m.value);
                });
            default:
                return super.__get(target, prop, receiver);
        }
    }
    __set(target, prop, value, receiver) {
        switch (prop) {
            case '_is_done':
                target.data._is_done = value;
                break;
            case 'is_done':
                receiver.status = !!value ? TaskModel.STATUS_DONE : TaskModel.STATUS_CREATED;
                if (receiver.status === TaskModel.STATUS_DONE) {
                    receiver.done_time = +getNow();
                }
                break;
            case 'photo_1':
                const genID = +getNow();
                saveImageToLocalDB(genID, value);
                super.__set(target, prop, `ref_${genID}`, receiver);
                break;
            default:
                super.__set(target, prop, value, receiver);
        }
        return true;
    }
}
TaskModel.STATUS_CREATED = 0;
TaskModel.STATUS_DONE = 2;
TaskModel.STATUS_FAILED = -1;
window.TaskModel = TaskModel;
